module.exports = __webpack_public_path__ + "img/android.20d7a507.png";